export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const formatDurationLabel = (purchasedData, insurancePolicy) => {
  const duration = purchasedData?.coverageDuration;
  if (duration?.display_unit && duration?.display_value) {
    const unit = duration.display_unit;
    const value = duration.display_value;
    return `${value} ${value === 1 ? unit.slice(0, -1) : unit}`;
  }
  if (duration?.hours) {
    const hours = duration.hours;
    return `${hours} ${hours === 1 ? "Hour" : "Hours"}`;
  }
  if (purchasedData?.duration && typeof purchasedData.duration === "string") {
    return purchasedData.duration;
  }

  const coverage = insurancePolicy?.coverage_durations?.[0];
  if (typeof coverage === "string") return coverage;
  if (coverage?.duration && typeof coverage.duration === "string") {
    return coverage.duration;
  }
  if (coverage?.display_unit && coverage?.display_value) {
    const unit = coverage.display_unit;
    const value = coverage.display_value;
    return `${value} ${value === 1 ? unit.slice(0, -1) : unit}`;
  }
  if (coverage?.hours) {
    const hours = coverage.hours;
    return `${hours} ${hours === 1 ? "Hour" : "Hours"}`;
  }
  if (purchasedData?.duration) return purchasedData.duration;
  return "1 Day";
};

const asSlug = (value) =>
  typeof value === "string" && value.trim() ? value.trim() : null;

const getProviderSlug = (purchasedData, insurancePolicy) => {
  if (purchasedData?.insurance_provider_slug) {
    return purchasedData.insurance_provider_slug;
  }
  const provider = insurancePolicy?.insurance_provider;
  if (!provider) return null;
  if (typeof provider === "object") {
    return asSlug(provider.slug) || asSlug(provider.id);
  }
  return asSlug(provider);
};

export const getClaimPolicySlug = (policy) =>
  asSlug(policy?.slug) ||
  asSlug(policy?.insurance_policy_slug) ||
  asSlug(policy?.number) ||
  asSlug(policy?.insurance_policy?.slug);

export const buildClaimFormPolicy = (policy) => {
  const purchasedData = policy?.purchased_policy_data || {};
  const insurancePolicy = policy?.insurance_policy || {};
  const durationLabel = formatDurationLabel(purchasedData, insurancePolicy);
  const policyName =
    insurancePolicy?.policy_name || purchasedData?.product_name || "Policy";
  const slug = getClaimPolicySlug(policy);

  return {
    slug,
    number: slug,
    provider: { name: policyName },
    category: `${durationLabel} cover`,
    status: policy.policy_status || "active",
    insurance_provider_slug: getProviderSlug(purchasedData, insurancePolicy),
    insurance_policy: insurancePolicy,
    customer: policy.customer || {},
    purchased_policy_data: purchasedData,
  };
};
